import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Page403 } from './pages/Page403';
import OrderList from './pages/OrderList';
import OrderDetails from './pages/OrderDetails';
import { useDispatch } from 'react-redux';
import { logout } from './feature/authSlice';
import { useEffect } from 'react';

function App() {

  const SESSION_DURATION = 86400000; 
  const dispatch = useDispatch()

  useEffect(() => {
    const loginTime = localStorage.getItem('loginTime')

    if (loginTime) {
      const now = Date.now()
      const expirationTime = parseInt(loginTime) + SESSION_DURATION

      if (now >= expirationTime) {
        dispatch(logout())
      } else {
        const timeout = expirationTime - now
        const timerId = setTimeout(() => {
          dispatch(logout())
        }, timeout)

        return () => clearTimeout(timerId)
      }
    }
  }, [dispatch])

  return (
    <BrowserRouter>     
      <Routes>
        <Route path="/" element={<Login/>} />
        <Route path="/management" element={<Dashboard/>} />
        <Route path="/403" element={<Page403/>} />
        <Route path="/orders" element={<OrderList/>} />
        <Route path="/orders/:id" element={<OrderDetails/>} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
